import type { Prismic } from '@landsbankinn/prismic';
import {
  fallbackRichText,
  fallbackText,
  getDataFromLink,
  PrismicLink,
} from '@landsbankinn/prismic';
import { Segment, TextCardButton } from '@landsbankinn/ui';
import React from 'react';
import { CardGroup } from '../components/card-group/CardGroup';
import { TextCard } from '../components/card/TextCard';

interface IProps {
  fields: IField[];
}

interface IField {
  title: Prismic.RichText;
  copy: Prismic.RichText;
  link: Prismic.Link;
  link_text: Prismic.RichText;
  style?: any;
}

type ITextCardItemProps = IField;

const TextCardItem = ({
  title,
  copy,
  link,
  link_text,
  style,
}: ITextCardItemProps) => {
  const linkdata = getDataFromLink(link);

  return (
    <TextCard
      title={fallbackText(title, linkdata.title ?? undefined)}
      description={fallbackRichText(copy, linkdata.abstract ?? undefined)}
      action={
        link && (
          <PrismicLink
            value={link}
            title={
              fallbackText(link_text, linkdata.title ?? undefined) ?? undefined
            }
          >
            <TextCardButton
              title={
                fallbackText(link_text, linkdata.title ?? undefined) ??
                undefined
              }
            />
          </PrismicLink>
        )
      }
      style={style}
    />
  );
};

export const TextCardsContainer = ({ fields }: IProps) => {
  if (fields.length === 0) {
    return null;
  }
  const fLength = fields.length;
  const count = fLength <= 4 ? fLength : 4;
  return (
    <Segment>
      <CardGroup columns={count}>
        {fields?.map((item, index) => (
          <TextCardItem key={`text-card-item-${index}`} {...item} />
        ))}
      </CardGroup>
    </Segment>
  );
};
